export default "__VITE_ASSET__CGigbsxI__"